export default __webpack_public_path__ + "static/media/dideban2.0140a768.jpg";